<template>
  <div class="teamBuildingDetail"  v-on:contextmenu="handleRightClick">
    <!-- <heads></heads> -->
    <div class="container" v-if="!loading">
      <div></div>
      <div class="container-bottom-out" ref="containerBottomOutRef"  >
        <div class="go-top el-icon-arrow-up" @click="toTop" id="topBtn" :class="showTopBtn?'':'show-none'" :style="{ top: topHeight } "></div>
        <div class="container-bottom" ref="containerBottomRef" >
          <div>
            <div class="child-page"                 
                v-for="tbInfo in tbInfoList"
                :key="tbInfo.id">
                 <headerPic v-if="tbInfo.templateType == 'fengmian'" :backgroundPic="tbInfo.image1"  :tb="detailResult" />                 
                 <gaishuPic v-else-if="tbInfo.templateType == 'gaishu' && tbInfo.isIndex == '0'"  :backgroundPic="tbInfo.image1"  :tb="detailResult" />                 
                 <xingchengPic v-else-if="tbInfo.templateType == 'xingcheng' && tbInfo.isIndex == '0'"  :backgroundPic="tbInfo.image1" 
                  :dayContent="dayContent" />                 
                 <zhutiPic v-else-if="tbInfo.templateType == 'zhuti' && tbInfo.isIndex == '0'"  :backgroundPic="tbInfo.image1"  :tb="detailResult"
                 :recommend="recommendTheme" :option="optionTheme"
                 />                 
                 <jingdianyulePic v-else-if="tbInfo.templateType == 'jingdianyule' && tbInfo.isIndex == '0'"  :backgroundPic="tbInfo.image1" 
                 :yuleRecommend="yuleRecommend" :jingdianRecommend="jingdianRecommend"
                 :tb="detailResult" />                 
                 <jiudiancanyinPic v-else-if="tbInfo.templateType == 'jiudiancanyin' && tbInfo.isIndex == '0'"  :backgroundPic="tbInfo.image1" 
                  :day="detailResult.day" :jiudianRecommend="jiudianRecommend"/>                 
                 <fullPic v-else-if="tbInfo.style == '1'" :pic="tbInfo.image1"  :link="tbInfo.link1"/>                 
                 <schedulePic v-else-if="tbInfo.style == '3'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <twoPic v-else-if="tbInfo.style == '4'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <twoPicWord v-else-if="tbInfo.style == '5'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <threePicAvg v-else-if="tbInfo.style == '6'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <threePic v-else-if="tbInfo.style == '7'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <fourPic v-else-if="tbInfo.style == '8'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <sixPic v-else-if="tbInfo.style == '9'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <eightPic v-else-if="tbInfo.style == '10'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
          </div> 
          </div>
        </div>
      </div>
    </div>
    <div class="loading-page" v-if="loading"  v-loading="loading">
      <!-- <el-empty description="加载中"></el-empty> -->
    </div>
    <el-dialog :visible.sync="requireDialogVisible" width="0%">
      <rquirementsForm
        :dialogVisible="requireDialogVisible"
        :dataForm="dataForm"
        v-on:getRequireDialogVisible="closeRequireDialogVisible"
      ></rquirementsForm>
    </el-dialog>
    <el-dialog
      class="qrcode-show"
      title="请微信扫码添加团建策划师，及时沟通更有效"
      :visible.sync="qrCodeDialogVisible"
      :before-close="closeQrCode"
      width="280px"
    >
      <img
        id="qrCode"
        :src="
          basicInfo.customQrCode
        "
        alt
      />
    </el-dialog>
    <!-- <quickContact :message="quickContactMessage"></quickContact> -->
    <homeFoots></homeFoots>
    
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import rquirementsForm from "@/components/comment/rquirementsForm.vue";
import quickContact from "@/components/comment/quickContact.vue";
import {handlePicPlusPre,isPhoneNumber,regEditorChange,fileAjax,downloadFile} from "@/util/util.js";
import axios from "axios"
import wxShare from "@/common/wx_share.js";
import fullPic from "@/components/comment/tbChildPage/fullPic"
import schedulePic from '@/components/comment/tbChildPage/schedulePic';
import coverPic from '@/components/comment/tbChildPage/coverPic';
import twoPic from '@/components/comment/tbChildPage/twoPic';
import twoPicWord from '@/components/comment/tbChildPage/twoPicWord';
import threePicAvg from '@/components/comment/tbChildPage/threePicAvg';
import threePic from '@/components/comment/tbChildPage/threePic';
import fourPic from '@/components/comment/tbChildPage/fourPic';
import sixPic from '@/components/comment/tbChildPage/sixPic';
import eightPic from '@/components/comment/tbChildPage/eightPic';
import headerPic from '@/components/comment/tbChildPage/headerPic';
import gaishuPic from '@/components/comment/tbChildPage/gaishuPic';
import jiudiancanyinPic from '@/components/comment/tbChildPage/jiudiancanyinPic';
import xingchengPic from '@/components/comment/tbChildPage/xingchengPic';
import jingdianyulePic from '@/components/comment/tbChildPage/jingdianyulePic';
import zhutiPic from '@/components/comment/tbChildPage/zhutiPic';
export default {
  name: "teamBuildingDetail",
  data() {
    return {
      nav: 0,
      navArray: ["团建特色", "行程介绍", "费用说明", "预订须知"],
      scrollTop: 0,
      divtop: 0,
      scroll: "",
      imageCount: 0,
      detailResult: [],
      dataForm: {
        title: "",
      },
      quickContactMessage:{
        type:1
      },
      requireDialogVisible: false,
      // 打分
      score: 1,
      iconClasses: ["el-icon-minus"],
      smsCodeTime: 0,
      // 提交表单
      form: {
        peopleNumber: null,
        avgPrice: null,
        activityDay: null,
        contact: null,
        mobile: "",
        verificationCode: "",
        wxNo: null,
        description: null,
      },
      //swiper配置
      swiperOptionTop: {
        autoplay: true,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        swiperLoading: false,
      },
      swiperOptionThumbs: {
        autoplay: true,
        direction: "vertical",
        spaceBetween: 5,
        slidesPerView: "auto",
        centeredSlides: true,
        touchRatio: 0.2,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slideToClickedSlide: true,
      },
      loading: false,
      qrCodeDialogVisible:false,
      // 详情列表
      tbInfoList:[],
      // 背景
      tbCover:"",
      // 关于我们
      tbBackCovers:[],
      //团建详情参数
      id: "",
      freeBookingStyle: 2,
      downloadLoading:false,
      // 天数内容
      dayContent:"",
      // 推荐主题
      recommendTheme:"",
      // 备选主题
      optionTheme:"",
      // 景区推荐
      jingdianRecommend:"",
      // 娱乐推荐
      yuleRecommend:"",
      // 酒店推荐
      jiudianRecommend:"",
      // 置顶按钮(是否显示)
      showTopBtn:false,
      // 监听器
      topBtnListener:null,
      // 距顶高度
      topHeight:"600px",
      // 置顶初始高度：
      initTopBtnHeight:"",
    };
  },
  watch: {},
  components: {
    heads,
    homeFoots,
    rquirementsForm,
    quickContact,
    fullPic,
    schedulePic,
    coverPic,
    twoPic,
    twoPicWord,
    threePicAvg,
    threePic,
    fourPic,
    sixPic,
    eightPic,
    headerPic,
    gaishuPic,
    jiudiancanyinPic,
    xingchengPic,
    jingdianyulePic,
    zhutiPic,
  },

  computed: {
    navId(index) {
      return function (index) {
        switch (index) {
          case 0:
            return "one";
            break;
          case 1:
            return "two";
            break;
          case 2:
            return "three";
            break;
          case 3:
            return "four";
            break;
        }
      };
    },
    getRequirementType() {
      return this.$store.state.requirementTypeData;
    },
    basicInfo() {
      return this.$store.state.webInfo;
    },
  },
  methods: {
    regEditorChange,
    isPhoneNumber,
    handlePicPlusPre,
    // 回到顶部
    toTop(){
      window.scrollTo({
        top: 0, // 滚动到页面顶部
        behavior: 'smooth' // 平滑滚动
      });
    },
    // 计算滚动距离
    computerScoller(){
      this.topBtnListener = (e) => {
        const btn= document.getElementById('topBtn');
        console.log("window.height",window.height)
        console.log("window-c",window)
        if(window.screen.height){
          this.initTopBtnHeight = window.screen.height -320 ;
        }
        // 如果页面滚动超过100px，显示按钮；否则隐藏按钮
        if (window.scrollY > 100) {
           this.showTopBtn = true;
        } else {
          this.showTopBtn = false;
        }
      this.topHeight = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0)
       + this.initTopBtnHeight+ "px";  
        console.log("topHeight",this.topHeight)
      };
      window.addEventListener('scroll', this.topBtnListener);
    },
    // 阻止右键
    handleRightClick (event) {
      event.preventDefault()
    },
    // 模块去重
    modelUnique(modelList){
      modelList =  modelList.filter((item, index, self) => 
            index === self.findIndex((item2) => item2.modelPageId === item.modelPageId));
      return modelList;   
    },
    // 获取团建详情
    teamBuildingDetail() {
      this.loading = true;
      axios.get(`/api/tb/` + this.id).then((res) => {
        if (res.data && res.data.code == 200) {
          this.detailResult = res.data.data;
          this.tbInfoList = this.detailResult.tbInfoList;
          this.tbCover = this.detailResult.tbCover;
          this.tbBackCovers = this.detailResult.tbBackCovers;
          if (this.detailResult.image) {
            this.detailResult.image = handlePicPlusPre(this.detailResult.image);
          }
          let {id,title,day,night,price,avgPrice,numberMax,numberMin} = this.detailResult
          this.dataForm= {
            id,title,day,night,price,avgPrice,numberMax,numberMin
          }
          if (this.detailResult.title) {
              document.title = this.detailResult.title;
          }
          if(day){
            for (let index = 1; index <= day; index++) {
              if(this.dayContent !=""){
                this.dayContent += "&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp; DAY"+index;
              }else{
                this.dayContent = "DAY1";
              }
            }
          }
          let zhutiList =  this.tbInfoList.filter(item => item.type=="zhuti" );
          zhutiList =  this.modelUnique(zhutiList);
          if(zhutiList.length>0){
            this.recommendTheme = zhutiList[0].name
          }
          if(zhutiList.length>1){
            for (let index = 1; index < zhutiList.length; index++) {
              if(this.optionTheme !=""){
                this.optionTheme += "&nbsp;/&nbsp;"+zhutiList[index].name;
              }else{
                this.optionTheme = zhutiList[index].name;
              }
            }          
          }
          let jingdianList =  this.tbInfoList.filter(item => item.type=="jingdian" );
          jingdianList =  this.modelUnique(jingdianList);
          if(jingdianList.length>0){
            for (let index = 0; index < jingdianList.length; index++) {
              if(this.jingdianRecommend !=""){
                this.jingdianRecommend += "&nbsp;/&nbsp;"+jingdianList[index].name;
              }else{
                this.jingdianRecommend = jingdianList[index].name;
              }
            }          
          }
          let yuleList =  this.tbInfoList.filter(item => item.type=="yule" );
          yuleList =  this.modelUnique(yuleList);
          if(yuleList.length>0){
            for (let index = 0; index < yuleList.length; index++) {
              if(this.yuleRecommend !=""){
                this.yuleRecommend += "&nbsp;/&nbsp;"+yuleList[index].name;
              }else{
                this.yuleRecommend = yuleList[index].name;
              }
            }          
          }
          let jiudianList =  this.tbInfoList.filter(item => item.type=="jiudian" );
          jiudianList =  this.modelUnique(jiudianList);
          if(jiudianList.length>0){
            for (let index = 0; index < jiudianList.length; index++) {
              if(this.jiudianRecommend !=""){
                this.jiudianRecommend += "&nbsp;/&nbsp;"+jiudianList[index].name;
              }else{
                this.jiudianRecommend = jiudianList[index].name;
              }
            }          
          }
          this.loading = false;
          // 微信分享
            if (wxShare.is_wx()) {
              wxShare.wxReWriteShare(
                `${this.detailResult.title}`,
                `${this.detailResult.introduce}`,
                `${window.location.href}`,
                `${
                  (this.detailResult.image && this.detailResult.image.length > 0)
                    ? this.detailResult.image[0]
                    : this.$store.state.defaultPic
                }`
              );
            }
        }
      }).catch (e=>{
        this.loading = true;
      });;
    },
    // 关闭微信咨询
    closeQrCode() {
      this.qrCodeDialogVisible = false;
    },
    // 打开微信咨询
    showQrCode() {
      this.qrCodeDialogVisible = true;
    },
    // 报价咨询
    goQuote(){
      this.$router.push({
        path: "/teamBuildingQuote",
        query: { tbId: this.id,numberMax:this.dataForm.number, numberMin:this.dataForm.numberMin, title:this.dataForm.title },
      });
    },
    /** 打开pdf */
    openTbPdf(pdfUrl,filename){
      let a = document.createElement("a");
      a.style.display = "none";
      a.download = filename;
      a.target = "_blank";
      a.href = pdfUrl;
      document.body.appendChild(a);
      a.click();
      this.loading = false;
      // document.body.remove(a);
    },
    // 下载pdf
    tbPdfDownload() {
      let that = this;
      if(this.detailResult.pdfUrl){
        // 下载pdf文件
      if(this.downloadLoading){
            return ;
      }
    this.downloadLoading = true;
      try{
        let url = this.detailResult.pdfUrl;
        console.log(url)
        // this.openTbPdf(url, that.detailResult.title);
        that.downloadLoading = false;
        fileAjax(url, function(xhr) {
          that.downloadLoading = false;
          downloadFile(xhr.response, that.detailResult.title)
        }, {
          responseType: 'blob'
        })
        }catch(e){
           that.downloadLoading = false;
                this.$message({
                  message: "下载出错",
                  type: "error",
                  duration: 1500,
                  center: true,
                });
        }
        }else{
          that.downloadLoading = false;
                this.$message({
                  message: "pdf链接失效，请联系管理员重新生成",
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
        }
    },
     clearForm(){
      // 提交表单
      this.form = {
        peopleNumber: null,
        avgPrice: null,
        activityDay: null,
        contact: null,
        mobile: "",
        verificationCode: "",
        wxNo: null,
        description: null,
      }
    },
    closeRequireDialogVisible(val) {
      this.requireDialogVisible = val;
    },
    // getNav(index) {
    //   this.nav = index;
    //   switch (index) {
    //     case 0:
    //       document.documentElement.scrollTop = this.oneTop + 1;
    //       break;
    //     case 1:
    //       document.documentElement.scrollTop = this.twoTop + 1;
    //       break;
    //     case 2:
    //       document.documentElement.scrollTop = this.threeTop + 1;
    //       break;
    //     case 3:
    //       document.documentElement.scrollTop = this.fourTop + 1;
    //       break;
    //     default:
    //       // console.log("!");
    //       document.documentElement.scrollTop = 0;
    //       break;
    //   }
    //   // console.log(document.documentElement.scrollTop);
    // },
    // getOffsetTop() {
    //   //创建节点选择器
    //   //减去导航栏高度40

    //   this.oneTop =
    //     // document.querySelectorAll("#one")[0].offsetTop - 40 + 115 ;
    //     document.querySelectorAll("#one")[0].offsetTop - 40;
    //   this.twoTop =
    //     // document.querySelectorAll("#two")[0].offsetTop - 40 + 115 ;
    //     document.querySelectorAll("#two")[0].offsetTop + 360;
    //   this.threeTop = document.querySelectorAll("#three")[0].offsetTop + 360;
    //   this.fourTop = document.querySelectorAll("#four")[0].offsetTop + 360;
    // },
    handleImgLoad() {
      //总计焦点图和缩略图数目,通过计数实现节流
      // const length = this.pageArray.linePictures.length * 2;
      let length = 1;
      if (this.imageCount < length - 1) {
        this.imageCount += 1;
      } else {
        const that = this;
        const timer = setTimeout(function () {
          // that.getOffsetTop();
          clearTimeout(timer);
        }, 500);
      }
    },

    // getScroll() {
    //   const scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;

    //   if (scrollTop >= this.oneTop && scrollTop < this.twoTop) {
    //     // console.log('1',this.nav);
    //     if (this.nav !== 0) {
    //       this.nav = 0;
    //     }
    //   } else if (scrollTop >= this.twoTop && scrollTop < this.threeTop) {
    //     if (this.nav !== 1) {
    //       this.nav = 1;
    //     }
    //   } else if (scrollTop >= this.threeTop && scrollTop < this.fourTop) {
    //     if (this.nav !== 2) {
    //       this.nav = 2;
    //     }
    //   } else if (scrollTop >= this.fourTop) {
    //     if (this.nav !== 3) {
    //       this.nav = 3;
    //     }
    //   } else {
    //     if (this.nav !== 0) {
    //       this.nav = 0;
    //     }
    //   }
    //   this.handleScrollx();
    // },

    // 计算免费定制的显示
    // handleScrollx() {
    //   let contentTopBottom =
    //     this.$refs.contentTopRef.getBoundingClientRect().bottom;
    //   let containerBottomBottom =
    //     this.$refs.containerBottomRef.getBoundingClientRect().bottom;
    //   let containerBottomTop =
    //     this.$refs.containerBottomRef.getBoundingClientRect().top;
    //   // let freeBookingBottom =
    //   //   this.$refs.freeBookingRef.getBoundingClientRect().bottom;
    //   let freeBookingRefHeight = this.$refs.freeBookingRef.offsetHeight;
    //   let condition1 = containerBottomTop - 60;
    //   if (
    //     condition1 <= 0 &&
    //     containerBottomBottom - freeBookingRefHeight - 60 >= 0
    //   ) {
    //     this.freeBookingStyle = 1;
    //     return;
    //   } else {
    //     this.freeBookingStyle = 2;
    //   }
    //   // // 计算触底位置
    //   // console.log(condition1);
    //   // console.log(containerBottomBottom);
    //   // 默认计算触顶位置
    //   let contentTopRefHeight = this.$refs.contentTopRef.offsetHeight;
    //   this.topHeight = contentTopRefHeight + 60 + "px";
    //   // // 计算触底位置
    //   // console.log(freeBookingRefHeight);
    //   // // 数据大于3条才会触发
    //   if (containerBottomBottom - freeBookingRefHeight - 60 < 0) {
    //     let containerBottomRef = this.$refs.containerBottomRef.offsetHeight;
    //     this.topHeight = containerBottomRef - 210 + "px";
    //   }
    // },
     // 发送短信
    // sendSMS() {
    //   if(this.smsCodeTime>0 || !isPhoneNumber(this.form.mobile)){
    //     return;
    //   }
    //   let params = { mobile: this.form.mobile };
    //   axios
    //     .get(`/api/verificationCode/sendCode`, {
    //       params,
    //     })
    //     .then((res) => {
    //       if (res.data) {
    //         if (res.data.code == 200) {
    //           // 成功则重置短信验证码时间
    //           this.smsCodeTime = 60;
    //           this.smsDown();
    //         } else {
    //           if (res.data.code == 500) {
    //             let msg = "";
    //             if (res.data.msg) {
    //               msg = res.data.msg;
    //             } else {
    //               msg = "短信发送失败";
    //             }
    //             this.$message({
    //               message: msg,
    //               type: "warning",
    //               duration: 1500,
    //               center: true,
    //             });
    //           }
    //         }
    //       }
    //     });
    // },
    // 短信计时器
    // smsDown() {
    //   setInterval(() => {
    //     if (this.smsCodeTime != 0) {
    //       this.smsCodeTime = this.smsCodeTime - 1;
    //     }
    //   }, 1000);
    // },
    // 提交表单
    // submit() {
    //   let { mobile, verificationCode } = this.form;
    //   // console.log(!mobile || mobile.length != 11);
    //   // console.log(!verificationCode);
    //   if (!mobile || mobile.length != 11) {
    //     this.$message({
    //       message: "请正确填写手机号码",
    //       type: "warning",
    //       duration: 1500,
    //       center: true,
    //     });
    //     return;
    //   }
    //   if (!verificationCode) {
    //     this.$message({
    //       message: "请正确填写验证码",
    //       type: "warning",
    //       duration: 1500,
    //       center: true,
    //     });
    //     return;
    //   }
    //   // this.form = {
    //   //   mobile,
    //   //   verificationCode,
    //   // };
    //   this.form.type = "1";
    //   let params = this.form;
    //   // let params = {
    //   //   peopleNumber: "",
    //   //   avgBudget: "",
    //   //   teamBuildingDay: "",
    //   //   contact: "",
    //   //   mobile: "",
    //   //   verificationCode: "",
    //   //   wxNo: "",
    //   //   description: "",
    //   // };
    //   axios
    //     .post(`/api/requirement/submit`, JSON.stringify(params), {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //       },
    //     })
    //     .then((res) => {
    //       // console.log(res);
    //       let msg = "";
    //       if (res.data) {
    //         if (res.data.code == 200) {
    //            if (res.data.msg) {
    //               msg = res.data.msg;
    //             } else {
    //               msg = "需求提交成功";
    //             }
    //             this.$message({
    //               message: msg,
    //               type: "success",
    //               center: true,
    //             });
    //             this.clearForm();
    //         } else {
    //           if (res.data.code == 500) {

    //             if (res.data.msg) {
    //               msg = res.data.msg;
    //             } else {
    //               msg = "需求提交失败";
    //             }
    //             this.$message({
    //               message: msg,
    //               type: "error",
    //               duration: 1500,
    //               center: true,
    //             });
    //           }
    //         }
    //       }
    //     });
    // },
  },
  destroyed(){
    window.removeEventListener("scroll",this.topBtnListener);
  },
  mounted() {
    // this.loading = true;
    // this.$nextTick(() => {
    //   this.swiperTop = this.$refs.swiperTop.swiper;
    //   this.swiperBottom = this.$refs.swiperBottom.swiper;

    //   // this.qrCode = new QRCode("qrcode", {
    //   //   width: 220, //二维码的宽度
    //   //   height: 220, //二维码的高度
    //   //   text: `http://www.1778hw.com/m/activity/teamBuildingDetail?id=${this.id}`
    //   // });
    // });
    this.$nextTick(()=>{
      this.computerScoller();
    })
    this.id = this.$route.query.id;
    this.teamBuildingDetail();
    // this.getOffsetTop();
    // window.addEventListener("scroll", this.getScroll, true);
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
    // window.addEventListener("scroll", this.handleScrollx,true);
  },
  created() {
  },
  // beforeDestroy() {
  //   window.removeEventListener("scroll", this.handleScroll);
  // }
  destroyed() {
    // window.removeEventListener("scroll", this.getScroll, true);
  },
};
</script>

<style scoped>
.teamBuildingDetail {
  width: 100%;
  height: 100%;
  background-color: #000000;
  padding-top: 15px;
}
.container {
  text-align: left;
  margin-bottom: 20px;
  width: 1060px;
}
.container-top-out {
  text-align: left;
  margin-bottom: 20px;
  width: 100%;
}

.content {
  width: 100%;
}

/* 头部图片 */

.container-top {
  background-color: #000;
  width: 1060px;
  display: flex;
  flex-direction: row;
}

.swiper-wrapper {
  flex: 1;
  background-color: #fff;
  height: 310px;
  vertical-align: center;
  text-align: center;
  padding: 10px;
  width: 530px;
}
.swiper-wrapper >>> .swiper-pagination-bullet {
  background: #e4e4e4 !important;
}
.swiper-wrapper >>> .swiper-pagination-bullet-active {
  background: #000000 !important;
}
.swiper-pagination >>> span {
  width: 12px !important;
  height: 12px !important;
}
.gallery-top {
  height: 100% !important;
  width: 100%;
}
.gallery-top .swiper-slide {
  height: 360px;
  width: 530px !important;
}
.swiper-content > img {
  width: 100%;
  height: 310px;
  background-size: cover;
  background-position: 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
  /* height: 100%; */
  /* height: 350px; */
}
.gallery-bottom-box {
  display: flex;
  margin-top: 12px;
}
.gallery-bottom-box .prev,
.gallery-bottom-box .next {
  flex: 1;
  background: #ccc;
  margin-bottom: 4px;
  font-size: 36px;

  display: flex;
  align-items: center;
  justify-content: center;
  /* text-align: center; */
}
.gallery-bottom-box .prev {
  margin-right: 8px;
}
.gallery-bottom-box .next {
  margin-left: 8px;
}
.gallery-bottom {
  height: 20% !important;
  /* width: 100%; */
  width: 86%;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  /* margin-top: 12px; */
  /* padding: 0 50px; */
}
.gallery-bottom .swiper-slide > img {
  width: 100%;
  box-sizing: border-box;
  height: 85px;
}
/* .gallery-bottom .swiper-slide-active img, */
.gallery-bottom .active img,
.gallery-bottom .swiper-slide > img:hover {
  border: 3px solid rgb(255, 80, 0);
}
.swiper-wrapper .swiper-button-gray {
  z-index: 2001;
  transition: all 0.2s ease-in-out;
  opacity: 0;
  color: #fff7;
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 30px;
}
.swiper-wrapper:hover .swiper-button-gray {
  z-index: 2001;
  transition: all 0.2s ease-in-out;
  opacity: 1;
  color: #fff7;
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 30px;
}
/* 头部文案 */
.header-text {
  flex: 1;
  padding: 10px;
  background-color: white;
  position: relative;
}
.header-text .header-title {
  font-weight: 700;
  font-size: 26px;
  color: #222;
  letter-spacing: 1px;
  line-height: 40px;
  overflow: hidden;
}
.header-text .header-purposes {
  margin-top: 12px;
}
.header-text .header-purposes span {
  padding: 0 6px;
  background: #359ff8;
  border-radius: 2px;
  height: 28px;
  line-height: 28px;
  display: inline-block;
  font-size: 12px;
  color: #fff;
  letter-spacing: 0;
  text-align: center;
  margin-right: 5.3px;
  margin-bottom: 5.3px;
}
.header-text .header-describe {
  margin-top: 16px;
  font-weight: 700;
  font-size: 14px;
  color: #999;
  letter-spacing: 1.4px;
  word-break: break-all;
  min-height: 42px;
  overflow: hidden;
}
.header-text .header-tags {
  margin-top: 10px;
}
.header-text .header-tags span {
  font-weight: 700;
  font-size: 12px;
  color: #222;
  line-height: 18px;
  height: 18px;
}
.header-text .header-submit {
  display: flex;
  flex-direction: row;
  padding-top: 10px;
  position: absolute;
  bottom: 20px;
}
.header-text .header-submit {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
}
.header-text .header-submit .header-required {
  background: #222;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  border-radius: 6px;
  padding: 10px 60px;
}
.header-text .header-submit .limit-btn {
  padding: 10px 30px!important;
}
.header-text .header-submit .header-consult {
  margin-left: 15px;
  background: transparent;
  padding: 10px;
  color: #18d3a0;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid #18d3a0;
  border-radius: 6px;
  padding: 10px 50px;
}
.header-text .header-submit .header-consult span {
  margin-left: 5px;
}
.header-text .header-price {
  position: absolute;
  /* left: 800px; */
  top: 200px;
  right: 10px;
  /* bottom: 70px; */
  font-weight: 700;
  font-size: 24px;
  color: #f9541c;
  text-align: right;
}

.header-text .header-price::after {
  content: "元起/人";
  font-weight: 700;
  font-size: 12px;
  color: #666;
  text-align: left;
  line-height: 28px;
}
.header-text .header-avg-price {
  position: absolute;
  /* left: 800px; */
  top: 230px;
  right: 10px;
  text-align: right;
}
.header-text .header-avg-price span {
  font-size: 12px;
  color: #666;
}
.container-top {
  background-color: #f8f8f8;
  width: 100%;
  display: flex;
  flex-direction: row;
}
.container-bottom {
  background-color: #000;
  width: 1060px;
  display: flex;
  flex-direction: column;
}
.container-bottom .child-page{
  padding: 10px 0; 
  width:100%;
  height: 600px;
}
/* 正文 */
.container-bottom > .text {
  width: 746px;
  background-color: #fff;
  min-height: 800px;
}
.text .textnav {
  display: flex;
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  /* padding: ; */
  box-sizing: border-box;
  background: #ffffff;
  position: sticky;
  position: -webkit-sticky;
  top: 60px;
  z-index: 1001;
}
.textnav > span {
  cursor: pointer;
  height: 100%;
  line-height: 60px;
  padding: 0 20px;
}
.nac-active {
  color: #359ff8;
  font-weight: bold;
  border-bottom: 5px solid #359ff8;
}
/* 正文内容 */
.text .article {
  position: relative;
}
.text .article .recommended {
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* align-items: center; */
}
.text .article .recommended .recommended-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: wrap;
  flex: 1;
  width: 60px;
  top: 22px;
  left: 0;
  position: relative;
  justify-content: baseline;
  text-align: center;
}
.text .article .recommended .recommended-left img {
  display: inline-block;
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 30px;
  overflow: hidden;
  background: #f8f8f8;
  border: none;
}
.recommended-left .middle-name {
  display: inline-block;
  width: 60%;
  font-weight: 700;
  font-size: 12px;
  color: #222;
  margin-top: 4px;
}
.recommended-left .bottom-name {
  display: inline-block;
  width: 60%;
  font-size: 12px;
  color: #18d3a1;
}
.recommended .recommended-right {
  display: flex;
  flex-direction: column;
  flex: 5;
  padding: 20px;
  background-color: #c2e2fd;
  border-radius: 6px;
  margin-right: 20px;
}
.recommended .recommended-right .exponents {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.recommended .recommended-right .exponent {
  flex: 50%;
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
}
.recommended .recommended-right .exponent .exponent-text {
  color: #222;
  font-size: 14px;
  font-weight: 700;
  padding-right: 5px;
  top: 4px;
}
.exponents-description {
  padding-top: 10px;
  width: 100%;
  display: block;
  font-size: 14px;
  color: #222;
  line-height: 24px;
}
.notes_text {
  margin: 20px;
}
.text .large-title {
  height: 60px;
  line-height: 60px;
  text-align: center;
  width: 100%;
}

.text .large-title .inner-title {
  display: inline-block;
  font-weight: 700;
  font-size: 30px;
  color: #222;
  letter-spacing: -0.71px;
  padding: 0 19px;
  vertical-align: middle;
}
.text .large-title .outside-dot {
  display: inline-block;
  background: #359ff8;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin: 0 10px;
  vertical-align: middle;
}
.text .large-title .inner-dot {
  display: inline-block;
  background: #359ff8;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  vertical-align: middle;
}

.text .second-title {
  height: 60px;
  line-height: 60px;
}
.text .second-title span:nth-child(1) {
  display: inline-block;
  background: #359ff8;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  vertical-align: middle;
}
.text .second-title .inner-title {
  display: inline-block;
  font-weight: 700;
  font-size: 18px;
  padding-left: 8px;
  color: #222;
  vertical-align: middle;
}
.text .building-topic {
}
.text .building-topic img {
  width: 100%;
  border-radius: 4px;
  background: #f8f8f8;
  background-size: cover;
}
.text .building-topic .topic-text {
  font-size: 14px;
  color: #222;
  line-height: 24px;
  padding: 10px 0;
}
.text .building-place {
}
.text .building-place .place-text {
}
.text .building-place .place-text .litte-title {
  font-weight: 700;
  font-size: 16px;
  color: #222;
  letter-spacing: 0;
  line-height: 44px;
}
.text .building-place .place-text p {
  font-size: 14px;
  color: #101010;
  line-height: 24px;
  padding-bottom: 20px;
}
.text .building-place .couple-img {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.text .building-place .couple-img img {
  flex: 1;
  padding: 5px;
  background-size: cover;
  width: 40%;
}
.tour-itinerary-item {
  position: relative;
}
.tour-header-item {
  position: relative;
  top: -35px;
  left: 0px;
}
.tour-header-item >>> .el-timeline-item__timestamp,
.tour-itinerary-item >>> .el-timeline-item__timestamp {
  color: #0000 !important;
}
.tour-header-item .tour-header-left {
  margin-right: 10px;
  padding-left: 0px;
  display: inline;
}
.tour-detail-header {
  position: relative;
  top: -13px;
  left: 0px;
}
.tour-detail-header .tour-header-left {
  margin-right: 10px;
  padding-left: 0px;
  display: inline;
}
.tour-header-right,
.tour-detail-left {
  margin-right: 10px;
  display: inline;
  font-weight: 700;
  font-size: 16px;
  color: #222;
  letter-spacing: 0;
  text-align: left;
}
.tour-header-right,
.tour-detail-right {
  margin-right: 10px;
  padding-left: 10px;
  display: inline;
}
.tour-header-item img {
  display: inline;
  /* color: #ffc53d; */
  /* font-size: 22px;
  padding: 0 10px; */
  width: 30px;
  /* line-height: 36px; */
  height: 30px;
  display: inline-block;
  vertical-align: middle;
}
.tour-header-item .icon {
  display: inline;
  position: absolute;
  left: -38px;
  top: 5px;
  width: 30px;
  height: 30px;
  background: #359ff8;
  border-radius: 50% 50% 50% 4%;
  transform: rotate(-45deg);
  color: #fff;
}
.tour-header-item .icon .day {
  transform: rotate(45deg);
  display: inline-block;
  position: relative;
  left: -7px;
  top: -5px;
  color: #fff;
}

.tour-header-item span {
  display: inline;
  font-weight: 700;
  font-size: 18px;
  width: 100%;
  color: #222;
  letter-spacing: 0;
  text-align: left;
  padding-left: 10px;
  height: 40px;
  line-height: 36px;
  margin-bottom: 20px;
  vertical-align: middle;
}
.tour-itinerary-item >>> .tour-header .el-timeline-item__timestamp {
  font-weight: 700;
  font-size: 18px;
  color: #222;
  letter-spacing: 0;
  text-align: left;
}
.tour-itinerary-item >>> .el-timeline-item__timestamp {
  font-weight: 700;
  font-size: 16px;
  color: #222;
  letter-spacing: 0;
  text-align: left;
  /* padding-left: 40px; */
  /* display: inline-block; */
}
.tour-itinerary-item p {
  font-size: 14px;
  color: #999;
  text-align: left;
  padding: 10px 0 10px 0px;
}

.tour-itinerary-item .tour-itinerary-couple-img {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
}
.tour-itinerary-item .tour-itinerary-couple-img img {
  flex: 1;
  padding: 10px 20px 10px 0px;
  background-size: cover;
  height: 243px;
  width: 100%;
  object-fit: cover;
}
.tour-detail-header .tour-detail-header-right {
  position: relative;
  display: inline;
}
.tour-detail-header .type-icon {
  width: 18px;
  height: 18px;
  position: absolute;
  left: -32px;
  top: 5px;
}
@media (min-width: 768px) {
  .tour-itinerary-couple-img img {
    display: block;
    flex: 0 0 50%;
    max-width: 46%;
  }
}
.three table{
  width: 100%;
}
.three table thead{
  width: 100%;
}
.three table thead td {
  color: #222;
  font-size: 18px;
  text-align: center;
  background-color: #c2e2fd;
  padding: 10px;
  width: 50%;
}
.three table tbody td {
  color: #222;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 30px;
  /* text-align: center; */
  background-color: #f8f8f8;
  padding: 10px;
  vertical-align: top;
}
.three table td {
  border: 1px solid #fff;
  width: 50%;
}
.three table tbody td .fee-content-item {
  padding: 10px;
  display: flex;
  flex-direction: row;
}
.three table tbody .fee-content-item span {
  font-weight: 700;
  flex: 1;
  font-size: 14px;
}
.three table tbody .fee-content-item p {
  flex: 4;
  font-size: 14px;
  text-align: left;
}
.three table tbody td .fee-without-item {
  padding: 10px;
  display: flex;
  flex-direction: row;
}
.three table tbody .fee-without-item span {
  position: relative;
  left: -6px;
  top: 6px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #666;
  display: block;
}
.three table tbody .fee-without-item p {
  flex: 4;
  font-size: 14px;
  text-align: left;

}
/* .three img,,.five-detail .img{
  width: 10
  0%;
} */
.three>>> img ,.four-detail>>> img,.five-detail>>> img{
  width: 100%;
}
.three table tbody td >>>ul,.four-detail>>>ul,.five-detail>>>ul{
  padding-left: 20px;
}
.three table tbody td >>>ul li,.four-detail>>>ul li,.five-detail>>>ul li{
  list-style: initial;
}

.four-detail {
  font-size: 14px;
  letter-spacing: 0;
  /* display: flex;
  flex-direction: row; */
}
.four-detail span {
  margin-top: 12px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #359ff8;
  flex: 1;
  display: block;
}
.four-detail p {
  font-size: 14px;
  color: #101010;
  letter-spacing: 0;
  line-height: 30px;
  padding-left: 16px;
  flex: 120;
}
.five-detail {
  font-size: 14px;
  letter-spacing: 0;
  /* display: flex;
  flex-direction: row; */
}
.five-detail span {
  /* margin-top: 12px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #359ff8;
  display: block;
  flex: 1; */
}
.five-detail p {
  font-size: 14px;
  color: #101010;
  letter-spacing: 0;
  line-height: 30px;
  padding-left: 16px;
  flex: 120;
}
/* 免费定制 */
.free-booking {
  left: auto;
  margin-top: 0px;
  width: 300px;

  /* bottom: 20px; */
  z-index: 0;
  margin-left: 756px;
  background: #fff;
  border: 2px solid #359ff8;
  border-radius: 3px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
}
.free-booking-1 {
  position: fixed;
  top: 80px;
}
.free-booking-2 {
  position: absolute;
  /* top: 750px; */
  /* position: relative;
    top: -2100px; */
}
.free-booking .free-booking-header {
  text-align: center;
}
.free-booking .free-booking-header .free-booking-dot {
  display: inline-block;
  background: #359ff8;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  vertical-align: middle;
  margin: 0 10px;
}
.free-booking .free-booking-header .free-booking-title {
  display: inline-block;
  font-weight: 700;
  font-size: 20px;
  color: #222;
  letter-spacing: 1px;
  height: 80px;
  line-height: 80px;
  vertical-align: middle;
}
.free-booking-item {
  position: relative;
  padding: 9px 25px 9px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
}
.free-booking-item .txt {
  display: inline;
  flex: 47;
  text-align: right;
  padding: 10px 5px 10px 0px;
}
.free-booking-item >>> div {
  flex: 100;
}

.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  background: #f8f8f8;
  border-radius: 6px;
}
/* el-select 样式 */
.free-booking-item >>> .el-input__inner,
.free-booking-item >>> .el-input__suffix {
  background-color: #f8f8f8;
}
/**微信二维码 */
.qrcode-show >>> .el-dialog__title{
  display: inline-block;
  margin-top: 40px;
  /* width: 250px; */
  text-align: center;
}
.qrcode-show >>> .el-dialog__body{
  padding-top:0px;
}
.qrcode-show >>> .el-dialog__body img{
  margin-top:0px;
}
.free-booking .free-booking-item2 >>> .el-input__inner {
  width: 170px !important;
}
.free-booking-item >>> .el-input__inner {
  border: none;
  width: 170px !important;
  background-color: #f8f8f8;
}
.free-booking-item .sendCode >>> .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 105px !important;
  margin-top: 0px !important;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161, 0.2);
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161);
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.request::before {
  content: "*";
  color: red;
  position: relative;
}
.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.free-booking-item .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.free-booking-item .txt {
  padding-top: 10px;
  display: block;
  width: 100%;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}

.free-booking-item-order .txt {
  padding-right: 5px;
  display: block;
  width: 100%;
}
.tool-button-primary button {
  color: #fff;
  font-weight: 700;
}
.tool-button button {
  outline: none;
  background: none;
  border: none;
  width: 250px;
  height: 100%;
  cursor: pointer;
}
.free-booking-itemimg {
  margin-top: 30px;
  width: 600px;
}
.element-row {
  flex-flow: row wrap;
}
.tool-button {
  width: 100%;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  color: #222;
  background: #222;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
}
.el-icon-eat {
  /* background: url('~@/assets/image/export.png') center no-repeat; */
  /* background-size: cover;*/
}
.el-icon-eat:before {
  content: "替";
  font-size: 16px;
  visibility: hidden;
}
.el-icon-eat {
  font-size: 16px;
}
.el-icon-eat:before {
  content: "\e611";
}
p img, .four-detail img,.five-detail .img{
  width: 100%;
}
.loading-page{
  height: 800px;
  width: 100%;
}
.container-bottom-out{
  position: relative;
}
.container-bottom-out .go-top{
  z-index: 9000;
  position: absolute;
  color: #fff;
  width: 60px;
  height: 60px;
  bottom: 10px;
  right: -70px;
  cursor: pointer;
  width: 60px;
  top: 600px;
  /* border: 2px solid #fff; */
  background: #999;
  text-align: center;
  font-size: 60px;
}
.show-none{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/teamBuildingview/teamBuildingDetail.vue